import React from 'react'
import 'raf/polyfill'
import 'babel-polyfill'
import { connect } from 'react-redux'
import comFn from '../../component/common/common'
import axios from 'axios'
import HeaderBar from '../../component/header/header.js'
import LeftNav from '../../component/left-nav/leftNav.js'
import Login from '../../component/login/login.js'
import './news.css'
import { Link} from "react-router-dom"
import {getBigBGUrl} from '../../redux/chatuser.redux.js'
@connect(
  state=>state.chatuser,
  {getBigBGUrl}
)
class NewsDetail extends React.Component{
	constructor(props){
		super(props)
		this.state={
			
      		newsDetail:''     		 		
    	} 		
    	
	}
	componentDidMount(){
  
    	this.getNewsDetail()

    
  	}
  	handleNewsOpt(itime){
      var num = itime.indexOf(' ')
     
      var mTime = itime.substring(0,num)
     	
       return mTime ||null
  	}
	getNewsDetail(){
	
		const _id = this.props.match.params.id
		
		axios.get('/fapi/news/getNews/'+_id+'_html')
		.then(res=>{
			
			if(res.data.return_code==0){
				this.setState({
					newsDetail:res.data.data
				})
			}
			
		})
	}
	render(){
		
		const data = this.state.newsDetail
		
		return (
			<div className="my-wrap" style={{backgroundImage :'url('+this.props.bigBg+')'}}>
				<HeaderBar></HeaderBar>
				<div className="news-box">
					<Login showLogin={this.props.showLogin}>
		               
		            </Login>
					<div className="new-con">
						<div className="news-from"><Link to="/index">首页</Link> > <Link to="/news-list">新闻公告</Link> > 详情</div>
						<div className="news-detail">
							<h6>{data.title}</h6>
							<span className="news-detail-time">{data.start_time?this.handleNewsOpt(data.start_time):null}</span>
							<div className="news-detail-con" dangerouslySetInnerHTML={{ __html: data.content}}></div>
						</div>

						
					</div>
				</div>
			</div>
		)
	}
}

export default NewsDetail



// WEBPACK FOOTER //
// ./src/container/news-detail/news.js